<template>
  <div class="rowGridFormat">
    <f7-grid class="menuIcon">
      <f7-col :width="centered ? 33 : 50" v-if="!hideSecondProfile">
        <center class="leftCol" v-bind:style="{'margin-left': marginValue + 'px'}">
          <slot name="leftCol"></slot>
        </center>
      </f7-col>
      <f7-col width="33" v-if="centered">
        <center class="centerCol">
          <slot name="centerCol"></slot>
        </center>
      </f7-col>
      <f7-col :width="centered ? 33 : 50">
        <center class="rightCol" v-bind:style="{'margin-right': marginValue + 'px'}">
          <slot name="rightCol"></slot>
        </center>
      </f7-col>
    </f7-grid>
  </div>
</template>

<script>
/* TLV 03/03/2020
* @brief Component permettant d'afficher des items sous forme d'une grille ordonnée.
*       Ce component est principalement utilisé sur le panneau de navigation de gauche (avec les boutons Received, Sent, Attachments, etc.)
*       et sur le bouton de "Service Switcher" pour changer de service (en haut à droite de la barre de navigation de l'appli)
* @param centered permet de savoir si on a deux éléments par ligne (dans ce cas il vaut false) ou trois (dans ce cas vaut true)
* @param hideSecondProfile : à chercher
*/
export default {
  name: 'rowGridMenu',
  props: {
    hideSecondProfile: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    /* largeur des items du menu */
    marginValue: {
      type: Number,
      default: 23
    }
  }
}
</script>

<style>
.row {
  margin-bottom: 50px;
}
.leftCol {
  margin-left: 25px !important;
}
.rightCol {
  margin-right: 25px !important;
}
<style>
